module.exports = __webpack_public_path__ + "static/media/cross-close.f1d9908c.svg";